import { ChartConfiguration } from 'chart.js/auto';
import { palettes } from '../ColorPalette';

export const lineChartSingle = () => {
  const config: ChartConfiguration<'line'> = {
    type: 'line',
    data: {
      labels: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
      datasets: [
        {
          label: 'Datasett 1',
          data: randomArray(10),
          backgroundColor: `${palettes.dark.Blue}`,
          borderColor: palettes.dark.Blue,
        },
      ],
    },
    options: {},
    plugins: [],
  };
  return config;
};

export const lineChartSmooth = () => {
  const config: ChartConfiguration<'line'> = {
    type: 'line',
    data: {
      labels: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
      datasets: [
        {
          label: 'Datasett 1',
          data: randomArray(10),
          backgroundColor: `${palettes.dark.Blue}`,
          borderColor: palettes.dark.Blue,
          tension: 0.3,
        },
      ],
    },
    options: {},
    plugins: [],
  };
  return config;
};

export const lineChartStyled = () => {
  const config: ChartConfiguration<'line'> = {
    type: 'line',
    data: {
      labels: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
      datasets: [
        {
          label: 'Datasett 1',
          data: randomArray(10),
          backgroundColor: `${palettes.dark.Blue}`,
          borderColor: palettes.dark.Blue,
          segment: {
            borderColor: '#464646',
            borderDash: [5, 5],
            borderWidth: 1,
          },
        },
      ],
    },
    options: {},
    plugins: [],
  };
  return config;
};

export const lineChartMultiple = () => {
  const config: ChartConfiguration<'line'> = {
    type: 'line',
    data: {
      labels: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
      datasets: [
        {
          label: 'Datasett 1',
          data: randomArray(10),
          backgroundColor: `${palettes.dark.Blue}`,
          borderColor: palettes.dark.Blue,
        },
        {
          label: 'Datasett 2',
          data: randomArray(10),
          backgroundColor: `${palettes.dark.Yellow}`,
          borderColor: palettes.dark.Yellow,
        },
        {
          label: 'Datasett 3',
          data: randomArray(10),
          backgroundColor: `${palettes.dark.Red}`,
          borderColor: palettes.dark.Red,
        },
        {
          label: 'Datasett 4',
          data: randomArray(10),
          backgroundColor: `${palettes.dark.Green}`,
          borderColor: palettes.dark.Green,
        },
      ],
    },
    options: {},
    plugins: [],
  };
  return config;
};

export const barChartSingle = () => {
  const config: ChartConfiguration<'bar'> = {
    type: 'bar',
    data: {
      labels: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
      datasets: [
        {
          label: 'Datasett 1',
          data: randomArray(10),
          backgroundColor: `${palettes.dark.Blue}`,
          borderColor: palettes.dark.Blue,
        },
      ],
    },
    options: {},
    plugins: [],
  };
  return config;
};

export const barChartStacked = () => {
  const config: ChartConfiguration<'bar'> = {
    type: 'bar',
    data: {
      labels: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
      datasets: [
        {
          label: 'Datasett 1',
          data: randomArray(10),
          backgroundColor: `${palettes.dark.Blue}`,
          borderColor: palettes.dark.Blue,
        },
        {
          label: 'Datasett 2',
          data: randomArray(10),
          backgroundColor: `${palettes.dark.Red}`,
          borderColor: palettes.dark.Red,
        },
        {
          label: 'Datasett 3',
          data: randomArray(10),
          backgroundColor: `${palettes.dark.Green}`,
          borderColor: palettes.dark.Green,
        },
      ],
    },
    options: {
      scales: {
        x: {
          stacked: true,
        },
        y: {
          stacked: true,
        },
      },
    },
    plugins: [],
  };
  return config;
};

export const barChartHorizontal = () => {
  const config: ChartConfiguration<'bar'> = {
    type: 'bar',
    data: {
      labels: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
      datasets: [
        {
          label: 'Datasett 1',
          data: randomArray(10),
          backgroundColor: `${palettes.dark.Blue}`,
          borderColor: palettes.dark.Blue,
        },
      ],
    },
    options: {
      indexAxis: 'y',
    },
    plugins: [],
  };
  return config;
};

export const barChartGrouped = () => {
  const config: ChartConfiguration<'bar'> = {
    type: 'bar',
    data: {
      labels: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
      datasets: [
        {
          label: 'Datasett 1',
          data: randomArray(10),
          backgroundColor: `${palettes.dark.Blue}`,
          borderColor: palettes.dark.Blue,
        },
        {
          label: 'Datasett 2',
          data: randomArray(10),
          backgroundColor: `${palettes.dark.Green}`,
          borderColor: palettes.dark.Green,
        },
      ],
    },
    options: {},
    plugins: [],
  };
  return config;
};

const random = () => Math.floor(Math.random() * 100);
const randomArray = (length: number) => Array.from({ length }, random);
